export const CLOUD_NAME = "diowgc7bf";

export const UPLOAD_PRESET = "storyline_upload";

export const CLOUDINARY_URL =
  `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`;

  // Video Upload URL
export const VIDEO_UPLOAD_URL =
  `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/video/upload`;